import React, { useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import Link from 'next/link'

// import Swiper core and required modules
import SwiperCore, { Autoplay, Navigation } from 'swiper'
import { recordGA4Event } from '@components/services/analytics/ga4'
import { useUI } from '@components/ui/context'
import { generateUri } from '@commerce/utils/uri-util'
import { IMG_PLACEHOLDER } from '@components/utils/textVariables'
import { EmptyGuid } from '@components/utils/constants'
import IntersectionObserverComponent, {
  IBannerData,
} from '@components/utils/IntersectionObserverComponent'
import { getImageNameFromURL } from '@framework/utils/app-util'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { useMoEngageEvent } from 'hooks/useMoengageEvent'
import { MO_ENGAGE_EVENT } from 'hooks/moengage_event.modal'

declare const window: any

// install Swiper modules
SwiperCore.use([Navigation])

const Hero = ({ data, deviceInfo, componentName, setHydrate }: any) => {
  const trackMoEngageEvent = useMoEngageEvent()

  const { user } = useUI()
  const bannerClick = (banner: IBannerData) => {
    trackMoEngageEvent(
      MO_ENGAGE_EVENT.BANNER_CLICK,
      {
        ...banner,
        previous_page_url: 'Home',
        URL: banner?.url,
      },
      window
    )

    recordGA4Event(window, GA_EVENT.BANNER_CLICK, {
      ...banner,
      current_page: 'Home',
      loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
    })
  }
  const { isMobile, isIPadorTablet } = deviceInfo
  const css = { maxWidth: '100%', height: 'auto' }

  useEffect(() => {
    setHydrate && setHydrate()
  }, [])

  return (
    <div
      className="relative bg-white home-banner-swiper m-hide-navigation py-3"
      id="home-banner-swiper"
    >
      <Swiper
        slidesPerView={1.1}
        spaceBetween={4}
        navigation={true}
        centeredSlides={true}
        loop={true}
        freeMode={true}
        modules={[Autoplay, Navigation]}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          640: {
            slidesPerView: 1.1,
          },
          768: {
            slidesPerView: 1.06,
          },
          1024: {
            slidesPerView: 1.06,
          },
        }}
        className="mySwiper"
      >
        {data &&
          data?.map((banner: any, idx: number) => {
            const bannerData: IBannerData = {
              position: idx + 1,
              banner_name: banner?.url ? getImageNameFromURL(banner?.url) : '',
              component_type: 'image',
              component_name: componentName,
              url: banner?.url ?? '',
            }
            return (
              <SwiperSlide key={idx}>
                <IntersectionObserverComponent
                  title="Home Banner"
                  eventName={GA_EVENT.BANNER_IMPRESSIONS}
                  bannerData={bannerData}
                >
                  <div className="relative mob-width-full-hero desk-hero-width-full">
                    <div className="flex flex-col w-full sm:hidden">
                      <Link legacyBehavior href={banner?.link || '#'}>
                        <a
                          className="image-container"
                          onClick={() => bannerClick(bannerData)}
                        >
                          <img
                            src={
                              generateUri(banner?.mobileUrl, 'h=900&q=70') ||
                              IMG_PLACEHOLDER
                            }
                            alt={bannerData?.banner_name || ''}
                            width={2000}
                            height={600}
                            // style={css}
                            style={{
                              objectFit: 'fill',
                              width: '100%',
                              position: 'relative',
                              objectPosition: 'top',
                              height: 'auto',
                            }}
                            className="sm:max-h-screen banner-Image mobile-banner"
                          />
                        </a>
                      </Link>
                    </div>
                    <div className="flex-col hidden w-full sm:flex">
                      <Link legacyBehavior href={banner?.link || '#'}>
                        <a
                          className="image-container"
                          onClick={() => bannerClick(bannerData)}
                        >
                          <img
                            src={
                              generateUri(banner?.url, 'h=1200&q=70') ||
                              IMG_PLACEHOLDER
                            }
                            width={2000}
                            height={600}
                            alt={bannerData?.banner_name || ''}
                            // style={css}
                            style={{
                              objectFit: 'fill',
                              width: '100%',
                              position: 'relative',
                              objectPosition: 'top',
                              height: 'auto',
                            }}
                            className="sm:max-h-screen banner-Image mobile-banner"
                          />
                        </a>
                      </Link>
                    </div>
                    {banner?.tag != null && (
                      <div className="absolute left-0 z-10 flex flex-1 top-5">
                        <label className="px-2 py-1 text-xs font-normal text-white bg-orange-500">
                          {banner?.tag}
                        </label>
                      </div>
                    )}
                  </div>
                </IntersectionObserverComponent>
              </SwiperSlide>
            )
          })}
      </Swiper>
    </div>
  )
}

export default Hero
